// import { CollectionCardSmall } from '@components/Cards/Collections/CollectionCardSmall';
// import { InfinityList } from '@components/InfinityList/InfinityList';
// import { useGetCollectionsInfinityList } from '@services/collection/hooks/useGetCollections';
// import { PageQueries } from '@specs/navigation';
// import { useRouter } from 'next/router';
// import React, { FC, useRef } from 'react';
// import { CollectionsSlider } from '../CollectionsSlider/CollectionsSlider';

// type CollectionsListProps = {
// }

// const limit = 10

// export const CollectionsList: FC<CollectionsListProps> = ({ }) => {
//     const router = useRouter()
//     const enabledRef = useRef(false)
//     const { query }: PageQueries = router.query

//     const {
//         data,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//         status,
//     } = useGetCollectionsInfinityList({
//         limit,
//         query,
//         sort: 'freshest',
//     }, {
//         enabled: enabledRef.current,
//     })

//     return (
//         <InfinityList
//             fetchNextPage={fetchNextPage}
//             data={data}
//             hasNextPage={hasNextPage}
//             isFetchingNextPage={isFetchingNextPage}
//             status={status}
//             enabledRef={enabledRef}
//             renderConfig={!query ? [
//                 {
//                     every: 7,
//                     component: (items) => <CollectionsSlider collections={items} />,
//                     itemsPerRender: 3,
//                 },
//             ] : undefined}
//             listClassName='_collectionsGrid'
//         >
//             {(item) => {
//                 return (
//                     <CollectionCardSmall {...item} imageId={item.imageid} />
//                 )
//             }}
//         </InfinityList>
//     )
// };

import React, { FC, useEffect, useRef } from 'react';
import { CollectionCardSmall } from '@components/Cards/Collections/CollectionCardSmall';
import { useGetCollections } from '@services/collection/hooks/useGetCollections';
import { PageQueries } from '@specs/navigation';
import { useRouter } from 'next/router';
import { PaginatedList } from '@components/PaginatedList/PaginatedList';
type CollectionsListProps = {};
const limit = 10;
export const CollectionsList: FC<CollectionsListProps> = ({}) => {
  const router = useRouter();
  const gridRef = useRef<HTMLDivElement>(null);
  const {
    query,
    page = '1'
  }: PageQueries = router.query;
  const currentPage = Number(page);
  const prevPageRef = useRef<number>(currentPage);
  const pageChangeRef = useRef(false);
  const {
    data,
    status
  } = useGetCollections({
    limit,
    skip: (currentPage - 1) * limit,
    query,
    sort: 'freshest'
  });
  const handlePageChange = (newPage: number) => {
    pageChangeRef.current = true;
    router.push({
      query: {
        ...router.query,
        page: newPage.toString()
      }
    }, undefined, {
      scroll: false
    });
  };
  useEffect(() => {
    if (currentPage !== prevPageRef.current) {
      pageChangeRef.current = true;
      prevPageRef.current = currentPage;
    }
    if (pageChangeRef.current && status === 'success' && data?.items.length) {
      if (gridRef.current) {
        window.scrollTo({
          top: gridRef.current.offsetTop - 100,
          behavior: 'smooth'
        });
      }
      pageChangeRef.current = false;
    }
  }, [currentPage, status, data]);
  return <div ref={gridRef} data-sentry-component="CollectionsList" data-sentry-source-file="CollectionsList.tsx">
            <PaginatedList data={data} currentPage={currentPage} onPageChange={handlePageChange} status={status} listClassName='_collectionsGrid' data-sentry-element="PaginatedList" data-sentry-source-file="CollectionsList.tsx">
                {item => <CollectionCardSmall {...item} imageId={item.imageid} />}
            </PaginatedList>
        </div>;
};